import { ReactNode, useCallback, useReducer } from "react";
import { AppHeaderContextAction, AppHeaderContextActionType, AppHeaderExportParams, AppHeaderStateType } from "./AppHeaderContextTypes";
import { AppHeaderContext } from "./AppHeaderContext";

const reducer = (state: AppHeaderStateType, action: AppHeaderContextAction): AppHeaderStateType => {
    switch (action.type) {

        case AppHeaderContextActionType.RefreshStateChanged:
            return {
                ...state,
                refreshActionEnabled: action.payload
            };

        case AppHeaderContextActionType.FavoriteStateChanged:
            return {
                ...state,
                favoriteActionEnabled: action.payload
            };


        case AppHeaderContextActionType.ExportStateChanged:

            return {
                ...state,
                exportExcelEnabled: action.payload.exportExcelEnabled,
                exportPDFEnabled: action.payload.exportPDFEnabled,
                saveGraphImageEnabled: action.payload.saveGraphImageEnabled,
                saveQuickGraphEnabled: action.payload.saveQuickGraphEnabled

                
            };

        case AppHeaderContextActionType.ResetChanged:
            return {
                ...defaultAppHeaderState
            }            

        default:
            return state;
    }
};

export type AppHeaderContextProviderProps = {
    children: ReactNode;
};


const defaultAppHeaderState: AppHeaderStateType = { 
    refreshActionEnabled: false,
    exportExcelEnabled: false,
    exportPDFEnabled: false,
    saveGraphImageEnabled: false,
    saveQuickGraphEnabled: false,

    favoriteActionEnabled: false,

};

export function AppHeaderContextProvider({ children }: AppHeaderContextProviderProps) {

    const [appHeaderContextState, dispatch] = useReducer(reducer, {...defaultAppHeaderState});

    const setRefreshActionState = useCallback((value: boolean) => {

        dispatch({
            type: AppHeaderContextActionType.RefreshStateChanged,
            payload: value
        })

    }, [
        dispatch
    ]);

    const setFavoriteActionState = useCallback((value: boolean) => {

        dispatch({
            type: AppHeaderContextActionType.FavoriteStateChanged,
            payload: value
        })

    }, [
        dispatch
    ]);


    const setExportActionState = useCallback((value: AppHeaderExportParams) => {

        dispatch({
            type: AppHeaderContextActionType.ExportStateChanged,
            payload: value
        })

    }, [
        dispatch
    ]);


    // const currentRoute = useMemo(() => {
    //     return getRouteFromPath(location.pathname);
    // }, [
    //     location.pathname
    // ]);

    // useEffect(() => {

    //     dispatch({
    //         type: AppHeaderContextActionType.ResetChanged,
    //         payload: undefined
    //     })
        
    // },[
    //     currentRoute?.viewID,
    //     dispatch
    // ]);

    // useEffect(() => {
    //     dispatch({
    //         type: AppHeaderContextActionType.ResetChanged,
    //         payload: undefined
    //     })
        
    // },[
    //     routeContext.contextObject,
    //     dispatch
    // ]);


    return (
        <AppHeaderContext.Provider value={{
            appHeaderContextState, 
            setRefreshActionState,
            setExportActionState,
            setFavoriteActionState
        }}>
            {children}
        </AppHeaderContext.Provider>
    );
}